import React, { ReactElement } from 'react';
import { MenuProps } from 'antd';
import { Trans } from 'react-i18next';
import { ColumnsType } from 'common/components/antd/Table/Table';
import { Tag } from 'common/components/antd/Tag/Tag';
import TableActionColumnDropdown from 'common/components/TableActionColumnDropdown/TableActionColumnDropdown';
import { RenderGUID } from 'domains/accounts/utils/render-account-iban';
import { EPermissionsTableColumnKey } from '../enums/permissions.enums';
import { SStatusCell } from '../permissions.page.style';
import { TPermissionsTableRecord } from '../types/permissions.types';

export const getColumns = ({
  menuItems,
  onItemActionClick,
}: {
  menuItems?: MenuProps['items'];
  onItemActionClick?: any;
} = {}): ColumnsType<TPermissionsTableRecord> => [
  {
    title: <Trans i18nKey="usrRoleMng.permissions.table.column.guid.title" />,
    width: 330,
    dataIndex: EPermissionsTableColumnKey.GUID,
	  render: (value, record, index): ReactElement => <RenderGUID value={value} index={index} />,
  },
	{
    title: <Trans i18nKey="usrRoleMng.permissions.table.column.defaultGroupName.title" />,
    width: 330,
    dataIndex: EPermissionsTableColumnKey.DefaultGroupName,
  },
	{
    title: <Trans i18nKey="usrRoleMng.permissions.table.column.defaultName.title" />,
    width: 330,
    dataIndex: EPermissionsTableColumnKey.DefaultName,
  },
	{
    title: <Trans i18nKey="usrRoleMng.permissions.table.column.ketoPermissionName.title" />,
    width: 330,
    dataIndex: EPermissionsTableColumnKey.KetoPermissionName,
  },
	{
    title: <Trans i18nKey="usrRoleMng.permissions.table.column.ketoScopeName.title" />,
    width: 330,
    dataIndex: EPermissionsTableColumnKey.KetoScopeName,
  },
  {
    title: <Trans i18nKey="usrRoleMng.permissions.table.column.ketoKind.title" />,
    width: 330,
    dataIndex: EPermissionsTableColumnKey.KetoKind,
  },
  {
    title: <Trans i18nKey="usrRoleMng.permissions.table.column.status.title" />,
    width: 200,
    key: EPermissionsTableColumnKey.Status,
    dataIndex: EPermissionsTableColumnKey.Status,
    searchable: false,
    render: (status: number) => (
      <SStatusCell>
        <Tag color={['green', 'volcano'][status]}>
          {
            [
              <Trans i18nKey="usrRoleMng.permissions.table.column.status.active" />,
              <Trans i18nKey="usrRoleMng.permissions.table.column.status.deleted" />,
            ][status]
          }
        </Tag>
      </SStatusCell>
    ),
  },
  {
    title: '',
    width: 20,
    key: EPermissionsTableColumnKey.Menu,
    dataIndex: EPermissionsTableColumnKey.Menu,
    searchable: false,
    render: (status: number, record: any) => (
      <TableActionColumnDropdown
        record={record}
        onClickItemAction={onItemActionClick}
        menuItems={menuItems}
      />
    ),
  },
];
